/* global axios */
import ApiClient from './ApiClient';

// Read-only Squareme customer context and Watchtower escalations for a
// conversation (squareme-next integration). Relay never changes an account
// itself: an escalation is a proposal that a person decides in Watchtower.
class SquaremeAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  customer(conversationId) {
    return axios.get(`${this.url}/${conversationId}/squareme_customer`);
  }

  activity(conversationId, params = {}) {
    return axios.get(
      `${this.url}/${conversationId}/squareme_customer/activity`,
      {
        params,
      }
    );
  }

  activityItem(conversationId, itemId) {
    return axios.get(
      `${this.url}/${conversationId}/squareme_customer/activity/${encodeURIComponent(itemId)}`
    );
  }

  escalations(conversationId) {
    return axios.get(`${this.url}/${conversationId}/squareme_escalations`);
  }

  escalate(conversationId, { actionType, payload, reason }) {
    return axios.post(`${this.url}/${conversationId}/squareme_escalations`, {
      action_type: actionType,
      payload,
      reason,
    });
  }
}

export default new SquaremeAPI();
